import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

// Register required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

class PieChart extends React.Component<{data: any, options: any},{}> {
    render() {
      const { data, options } = this.props; // Accept data and options as props
      return <Pie data={data} options={options} />;
    }
  }
  
  export default PieChart;
